// expressed as milliseconds
export var Duration;
(function (Duration) {
    Duration[Duration["NONE"] = 0] = "NONE";
    Duration[Duration["t1"] = 1500] = "t1";
    Duration[Duration["t2"] = 300] = "t2";
    Duration[Duration["t3"] = 250] = "t3";
    Duration[Duration["t4"] = 200] = "t4";
    Duration[Duration["t5"] = 100] = "t5";
})(Duration || (Duration = {}));
export var Easing;
(function (Easing) {
    Easing["slow"] = "cubic-bezier(0.4, 0, 0.2, 1)";
    Easing["tada"] = "cubic-bezier(0.4, 0, 1, 1)";
})(Easing || (Easing = {}));
export function propertyTransition(property, duration, easing) {
    return `${property} ${duration}ms ${easing}`;
}
export function transition(duration, easing) {
    return propertyTransition('all', duration, easing);
}
